module.exports = __webpack_public_path__ + "img/sale_center_bg.de0abcf8.png";